import React from 'react';
import { useState, useEffect } from 'react';
import nexusLogo from '../assets/logo.png'
import {get_apps,userLogout} from '../../../api/api.js';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';


function Header() {
    //const location=useLocation();
    const devEnv = process.env.REACT_APP_IS_DEV
    const [userApps, setUserApps] = useState([]);
    const logout = async()=>{
        const response = await userLogout();
        if(response.status===200){
            window.location.href='/login'
        }
      }
      const getuserapps = async () => {
       
        const response = await get_apps();
        if(response.status===200 && response.data.length>0){
            const appnames = response.data.map((item, i) => ({
                key: i,
                label: item.appname,
                value: item.logo,
                url:item.appurl
              }));
            setUserApps(appnames);
        }
    }

    const loadProfile=()=>{
	window.location.href='/profile'
    }

   /* const loadProfile = () => {
	    #if(parseInt(devEnv)===1){
		    #console.log(typeof(devEnv));
        window.location.href='/profile'
		   }
  
  
    }*/
    useEffect(()=>{     
        getuserapps();
    },[])
    return (
      <Navbar expand="x-lg" className="fixed-navbar">
      <img className='brand' src={nexusLogo} alt="Logo" />
      <h4 className='heading underline`'>Nexus Data Flow Hub</h4>
      <div className='buttondiv'>
      
      <Button className="buttonstyle" onClick={loadProfile}><span class="text">Profile</span></Button>
      <Button className="buttonstyle" onClick={logout}><span class="text">Logout</span></Button>
      
      </div>
      

      </Navbar>
    );
  }
  
  export default Header;
